var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.config.isDetailDisplay),expression:"!config.isDetailDisplay"}],class:_vm.config.isDetailDisplay ? 'small-list' : 'scroll-auto'},[_c('Control',{ref:"control",attrs:{"config":_vm.config}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }